import { RTABAK_URLS } from "../utils/urls";
import request from "./request";

type ProductParams = {
  department?: string;
  query?: string;
  skip?: number;
  limit?: number;
  material?: string;
  color?: string;
  subcategory?: string[];
  custom?: boolean;
  friendlyUrl?: string;
  order?: string;
  search?: string;
};

const ProductServices = {
  getProducts: async (params?: ProductParams): Promise<any> => {
    return await request({
      method: "get",
      baseURL: RTABAK_URLS.API.GetProducts,
      params,
    });
  },
  getProductsAdmin: async (params?: ProductParams): Promise<any> => {
    return await request({
      method: "get",
      baseURL: RTABAK_URLS.API.GetProducts + "/admin",
      params,
    });
  },
  getProductsCatalog: async (params?: ProductParams): Promise<any> => {
    return await request({
      method: "get",
      baseURL: RTABAK_URLS.API.GetProducts + "/catalog",
      params,
    });
  },
  getProductsSpreadsheet: async (): Promise<any> => {
    return await request({
      method: "get",
      baseURL: RTABAK_URLS.API.GetProductsSpreadsheet,
    });
  },
  getProductByFriendlyUrl: async (params?: ProductParams): Promise<any> => {
    return await request({
      method: "get",
      baseURL: RTABAK_URLS.API.GetProductById + params?.friendlyUrl,
    });
  },
  createCategory: (customs: Customs, product: Product): string => {
    let res = product.department + "|" + product.material;
    customs?.pendant && (res = res + "|" + "pendant");
    customs?.rock && (res = res + "|" + "rock");
    customs?.solid && (res = res + "|" + "solid");
    customs?.hollow && (res = res + "|" + "hollow");
    customs?.highlighted && (res = res + "|" + "HIGHLIGHTED");
    return res;
  },
  getProductsLabels: (
    category: string,
    department: string,
    isCustom: boolean
  ): LenghtLabel => {
    const isSolid =
      (department == "chain" || "brazalete") &&
      !category.includes("pendant") &&
      !category.includes("rock") &&
      !category.includes("hollow") &&
      !category.includes("hoop") &&
      !category.includes("finding") &&
      !isCustom
        ? true
        : false;
    if ((department != "brazalete" && department != "chain") || !isSolid) {
      return {
        gaugeLabel: "Espesor",
        lenghtLabel: "Medidas",
        gaugeTable: "Esp.",
        lenghtTable: "Medidas",
        unit: "",
        cartGaugeLabel: "Esp.",
        cartLenghtLabel: "Med.",
      };
    } else {
      return {
        gaugeLabel: "Hilo",
        lenghtLabel: "Largo",
        gaugeTable: "Hilo",
        lenghtTable: "Largo",
        unit: "cm",
        cartGaugeLabel: "Hilo",
        cartLenghtLabel: "Largo",
      };
    }
  },
  /*getProductsCategories: (department: string): CategorySelect[] => {
    switch (department) {
      case "chain":
        return [
          { value: "pendant", label: "Con dije" },
          { value: "rock", label: "Con piedra" },
          { value: "hollow", label: "Hueca" },
          { value: "solid", label: "Maciza" },
          { value: "isCustom", label: "Personalizable" },
        ];
      case "brazalete":
        return [
          { value: "pendant", label: "Con dije" },
          { value: "rock", label: "Con piedra" },
          { value: "hollow", label: "Hueca" },
          { value: "solid", label: "Maciza" },
          { value: "isCustom", label: "Personalizable" },
          { value: "identity", label: "Identidad" },
        ];
      case "pendant":
        return [
          { value: "all", label: "Todos" },
          { value: "rock", label: "Con piedra" },
          { value: "medals", label: "Para grabar" },
          { value: "child", label: "Niños" },
          { value: "hanger", label: "Perchas" },
          { value: "religion", label: "Religión" },
          { value: "sports", label: "Deportes" },
          { value: "identity", label: "Identidad" },
        ];
      case "ring":
        return [
          { value: "all", label: "Todos" },
          { value: "isCustom", label: "Personalizable" },
        ];
      default:
        return [
          { value: "all", label: "Todos" },
          { value: "hollow", label: "Hueca" },
          { value: "solid", label: "Maciza" },
          { value: "isCustom", label: "Personalizable" },
          { value: "identity", label: "Identidad" },
          { value: "rock", label: "Con piedra" },
          { value: "medals", label: "Medallas" },
          { value: "child", label: "Niños" },
          { value: "hanger", label: "Perchas" },
          { value: "religion", label: "Religión" },
          { value: "sports", label: "Deportes" },
          { value: "identity", label: "Identidad" },
        ];
    }
  },
*/
  getCategoriesbyDepartment: async (department: string) => {
    const categories = await request({
      baseURL: RTABAK_URLS.API.GetCategorybyDepartment + "/" + department,
      method: "get",
    });
    categories.data.unshift({ value: "all", label: "Todos" });
    const others =
      categories.data.find((el: any) => el.value == "others") || null;
    if (others) {
      categories.data.splice(
        0,
        categories.data.length,
        ...categories.data.filter((el: any) => el.value != "others")
      );
      categories.data.push(others);
    }
    return categories;
  },
  getAllCategories: async () => {
    return request({
      baseURL: RTABAK_URLS.API.GetCategorybyDepartment + "/all",
      method: "get",
    });
  },
  showDescription: (category: string, categories: CategorySelect[]) => {
    const show = categories.find(
      (el: CategorySelect) => el.value == category
    )?.description;
    return show;
  },
};
export { ProductServices };
